import type { WritableSignal } from '@angular/core';

export async function fetchData<T>(
  apiCall: Promise<T>,
  callback: (response: NonNullable<T>) => void,
  loading?: WritableSignal<boolean>,
): Promise<void> {
  loading?.set(true);

  try {
    const response = await apiCall;

    if (!response) {
      return;
    }

    callback(response);
  } finally {
    loading?.set(false);
  }
}
